export function currentLayout() {
  const layouts = Object.keys(StyleBitz.Layouts);
  return layouts.find(
    (layout) => matchMedia(StyleBitz.Layouts[layout]).matches
  );
}

export function isInViewport(el) {
  if (typeof jQuery === 'function' && el instanceof jQuery) {
    el = el[0];
  }
  const rect = el.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}

export function srcsetData(attr) {
  const sets = [];
  const srcs = attr.split(', ');
  srcs.forEach((src) => {
    const [img, size] = src.split(' ');
    const imgsize = [img, size].filter(String);
    sets.push(imgsize);
  });
  return sets;
}
